import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPersonFill = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 16,
	viewBox: "0 0 17 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M1.83333 16C1.83333 16 0.5 16 0.5 14.6667C0.5 13.3333 1.83333 9.33333 8.5 9.33333C15.1667 9.33333 16.5 13.3333 16.5 14.6667C16.5 16 15.1667 16 15.1667 16H1.83333Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.5 8C10.7091 8 12.5 6.20914 12.5 4C12.5 1.79086 10.7091 0 8.5 0C6.29086 0 4.5 1.79086 4.5 4C4.5 6.20914 6.29086 8 8.5 8Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgPersonFill);
export default ForwardRef;
